// extracted by mini-css-extract-plugin
module.exports =  {"container":"ta240K7","centered":"ZAtGc_u","mobile-responsive":"najFDPp","mobileResponsive":"najFDPp"};